import { useFavoriteInvestorMutation } from 'generated/graphql';
import { useLoading } from 'modules';



export function useFavoriteInvestor() {
  const [favoriteInvestor, tuple] = __useFavoriteInvestorMutation();
  const loading = useLoading([tuple]);

  return {
    loading,
    mutations: { favoriteInvestor }
  };
}



function __useFavoriteInvestorMutation() {
  const [fnMutate, tuple] = useFavoriteInvestorMutation();

  async function fnWrappedMutate(investorUserId: string, isFavorited: boolean) {
    await fnMutate({
      variables: {
        input: {
          favoritedInvestorUserId: investorUserId,
          isFavorited
        }
      }
    });
  }

  return [
    fnWrappedMutate,
    {
      ...tuple,
      data: null
    }
  ] as const;
}
